const CMTS_GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isCmtsGuid(value: unknown): value is string {
  return typeof value === "string" && CMTS_GUID_PATTERN.test(value.trim());
}

export function requireCmtsGuid(value: unknown, operation: string): string {
  if (!isCmtsGuid(value)) {
    throw new Error(`${operation} requires a backend GUID id.`);
  }
  return value.trim();
}

export function optionalCmtsGuid(value: unknown): string | undefined {
  return isCmtsGuid(value) ? value.trim() : undefined;
}
